export enum ProduceButtonTodayState {
  ActiveToday = "ActiveToday",
  InactiveToday = "InactiveToday",
}
